import config from "./../config";


export const fetchFeatureFlags = async (): Promise<Record<string, boolean>> => {
    try {
        let featureFlagsUrl = config.API_BASE_URL + "feature-flags/";
        const response = await fetch(featureFlagsUrl);
        if (!response.ok) throw new Error("Failed to fetch feature flags");

        const data: Record<string, boolean> = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching feature flags:", error);
        return {};
    }
};
